export const BANKS_LIST = "BANKS_LIST";
export const BANKS_CREATE = "BANKS_CREATE";
export const BANKS_UPDATE = "BANKS_UPDATE";
export const BANKS_DELETE = "BANKS_DELETE";
export const BANKS_SHOW = "BANKS_SHOW";
export const BANKS_PUBLIC_LIST = "BANKS_PUBLIC_LIST";
